<template>
  <div id="dataDictionary-edit">
    <IForm ref="formInline" :model="edit" :elem="dataDictionaryElem" :rules="dataDictionaryRule"
           :label-width="70" @on-submit="toSubmit" :submit="false" :showMessage="true">

      <div slot="extend">
        <Row>
          <Col span="24"><FormItem label="名称" prop="name" ><el-input v-model="edit.name" type="text" placeholder="请输入名称" :clearable="true"  maxlength="50"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24"><FormItem label="编码" prop="code" ><el-input v-model="edit.code" type="text" placeholder="请输入编码" :clearable="true"  maxlength="50"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24"><FormItem label="项目值" prop="value"><el-input v-model="edit.value" type="textarea" placeholder="请输入项目值" :clearable="true":rows="5" maxlength="1024"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="状态" prop="enabled">
              <Select v-model="edit.enabled">
                <Option v-for="item in enabledList" :value="item.value" v-bind:key="item.value" >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </div>
    </IForm>
  </div>
</template>
<script>
import { _get, _edit } from "@/services/manage/dataDictionary";
export default {
  name: "dataDictionaryEdit",
  data() {
    return {
      edit: {
        id: "",
        name: "",
        code: "",
        value: "",
        enabled: 1
      },
      enabledList:[
        {label: '启用', value: 1},
        {label: '停用', value: 2},
      ],
      init: "",
      dataDictionaryElem: [

      ],
      dataDictionaryRule: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "名称不能为空"
          }
        ],
        code: [
          {
            required: true,
            trigger: "blur",
            message: "编码不能为空"
          }
        ],
        value: [
          {
            required: true,
            trigger: "blur",
            message: "项目值不能为空"
          }
        ],
        enabled: [
          {
            required: true,
            trigger: "blur",
            message: "状态不能为空",
            type:'number'
          }
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    handleModal(row) {
      this.$refs["formInline"].handleReset();
      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      this.edit = Object.assign({}, row);
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      _edit(this.edit).then(res => {
        if (res.errcode == 1){
          this.$message.success(res.errmsg);
          this.$emit("on-submit", false);
        } else{
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    toInt(){
      if(this.edit.count){
        this.edit.count = (this.edit.count + "").replace(/[^\d]+/g, '');
        this.edit.count = (this.edit.count + "").replace('.', '');
        this.edit.count = (this.edit.count + "").replace(/\./g, '');
        this.edit.count = (this.edit.count + "").replace(/\\./g, '');
        this.edit.count = (this.edit.count + "").replace('$#$', '');
      }
    }
  },
};
</script>
<style lang="postcss" scoped>

</style>
